const SETTINGS_KEY = 'ADMIN_SETTINGS';

export interface AdminSettings {
  availableDatacenters: string[];
  routerBetaEnabled?: boolean;
  myDivisionFilterEnabled?: boolean;
  emailAddressOverride?: string;
}

export const DATACENTERS = [
  { code: 'aws-us-west-2', name: 'US (AWS)' },
  { code: 'gcp-us-west1', name: 'US (GCP)' },
  { code: 'aws-ap-south-1', name: 'India (AWS)' },
  { code: 'gcp-europe-west3', name: 'EU (GCP)' },
  { code: 'aws-cn-north-1', name: 'China (AWS)' },
] as const;

function getSettings(): AdminSettings {
  try {
    const settingsStr = localStorage.getItem(SETTINGS_KEY);
    if (settingsStr) {
      return JSON.parse(settingsStr);
    }
  } catch {
    // Fall through
  }

  return { availableDatacenters: [] };
}

function saveSettings(settings: AdminSettings): void {
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
}

export function getAvailableDatacenters(): string[] {
  return getSettings().availableDatacenters || [];
}

export function setAvailableDatacenters(datacenters: string[]): void {
  const settings = getSettings();
  settings.availableDatacenters = datacenters;
  saveSettings(settings);
}

export function toggleDatacenter(dc: string): string[] {
  const available = getAvailableDatacenters();
  const index = available.indexOf(dc);

  if (index > -1) {
    available.splice(index, 1);
  } else {
    available.push(dc);
  }

  setAvailableDatacenters(available);

  return available;
}

export function isDatacenterEnabled(dc: string): boolean {
  return getAvailableDatacenters().includes(dc);
}

export function isRouterBetaEnabled(): boolean {
  // Default to true if not explicitly set
  const settings = getSettings();
  return settings.routerBetaEnabled !== false;
}

export function toggleRouterBeta(): boolean {
  const settings = getSettings();
  // If undefined (default true), toggle to false. Otherwise toggle normally.
  const currentValue = settings.routerBetaEnabled !== false;
  settings.routerBetaEnabled = !currentValue;
  saveSettings(settings);

  return settings.routerBetaEnabled;
}
